import { PRODDOMAIN } from "@/utils";
import axios from "axios";
import { GetServerSideProps } from "next";
import Head from "next/head";

const getServerSideProps: GetServerSideProps = async context => {
  const lang = context.resolvedUrl.slice(0, 3) === '/en' ? 'en' : 'cn'

  const { data } = await axios.get(`${PRODDOMAIN}/home/menu_info`, {
    params: {
      pathinfo: (lang === 'en' ? context.resolvedUrl.slice(3) : context.resolvedUrl) || '/'
    }
  });

  let newData = {}
  if (data.code == 1) {
    newData = {
      ...data.data,
      seo_title: data.data[`seo_title_${lang}`]
        || (lang === 'cn' ? "2025亚洲有机产业展览会 | 有机产品与可持续发展盛会"
          : "Organic Festa Asia 2025 | Premier Exhibition for Organic Products and Sustainable Development"),
      title: data.data[`title_${lang}`],
      content: data.data[`content_${lang}`],
      // brief: data.data[`brief_${lang}`],
      seo_desc: data.data[`seo_desc_${lang}`]
        || (lang === 'cn' ? "亚洲有机产业展览会，有机产品展览，2025上海有机展，可持续发展，国际有机贸易平台"
          : "Organic Festa Asia, organic products exhibition, 2025 Shanghai organic expo, sustainable development, international organic trade platform"),
      seo_keyword: data.data[`seo_keyword_${lang}`]
        || (lang === 'cn' ?
          "欢迎参加将于2025年9月3日至5日在上海举办的亚洲有机产业展览会。汇聚全球顶尖有机品牌、专业买家和行业专家，探索有机产品与可持续发展的最新趋势和商机。"
          : "Join us at the Organic Festa Asia 2025, taking place from September 3 to 5 in Shanghai. Connect with leading organic brands, professional buyers, and industry experts worldwide to explore the latest trends and opportunities in organic products and sustainable development.")
    }
  }

  return {
    props: {
      navDetail: newData || {},
    },
  };
};

const getHead = (navDetail: any) => {
  return (<Head>
    <title>{navDetail?.seo_title} </title>
    <meta name="keywords" content={navDetail?.seo_keyword} />
    <meta name="description" content={navDetail?.seo_desc} />
  </Head>)
}
export { getHead, getServerSideProps }
